import React from "react";
import "./navbar.css"; 

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img
          src="/images/companylogo.png"
          alt="Company Logo"
          style={{ width: "50px" }}
        />
      </div>
      <div className="navbar-items">
        <p>Free Invoice Generator</p>
        <h4>By PearlaX</h4>
      </div>
    </nav>
  );
};

export default Navbar;
